export interface ReqContracts {
  customerID: string;
}

export enum C_SERVICE_TYPE {
  ONE = 1, // 代理记账
  TWO = 2, // 工商注册；
  THREE = 3, // 其它服务
}

export enum RENEW_STATE {
  ONE = 1, // 是
  TWO = 2, // 否
}

export enum C_STATE {
  ONE = 1, // 未开始
  TWO = 2, // 未完成
  THREE = 3, // 已完成
  FOUR = 4, // 已终止
}

export interface Tasks {
  id: number;
  cTaskID: string;
  cCompanyID: string;
  cCustomerID: string;
  cContractID: string;
  cSerDetailsID: string;
  cName: string;
  cUserID: string;
  cStartDate: string;
  cEndDate: string;
  cLimit: number;
  cCommission: number;
  cState: C_STATE;
  cOrder: number;
}

export interface Costs {
  appAmount: number;
  id: number;
  cCostID: string;
  cCompanyID: string;
  cCustomerID: string;
  cContractID: string;
  ccTaskID: string;
  cName: string;
  cReceivable: number;
  cReceive: number;
  cDiscount: number;
  cReceivableDate: string;
  cIsAdvance: true;
  otherChargeNameId: number;
}

export interface ResContracts {
  id: number;
  conStopState: boolean;
  cContractID: string;
  cCompanyID: string;
  cCustomerID: string;
  cServiceType: C_SERVICE_TYPE;
  cServiceID: string;
  cIncomeNumber: string;
  cNumber: string;
  cStartDate: string;
  cPeriod: number;
  cEndDate: string;
  cMonthPrice: number;
  cBooksPrice: number;
  cOtherPrice: number;
  cPayMode: number;
  cPreway: true;
  cProducer: string;
  cBrokerage: string;
  cAuditor: string;
  cRemarks: string;
  cTime: string;
  cStop: boolean;
  cStopDate: string;
  cTotalAmount: number;
  cIsDispatch: true;
  cIntroducerID: string;
  cIntroducerAmount: number;
  cAppFlowID: string;
  cNowOrder: number;
  cAppResult: number;
  cTax_rate: string;
  renewState: RENEW_STATE;
  renewContractId: string;
  contractPrice: number;
  contractFavorable: number;
  actualAmount: number;
  freeTime: number;
  serviceModel: {
    id: number;
    cServiceID: string;
    cCompanyID: string;
    cNumber: string;
    cName: string;
    cType: C_SERVICE_TYPE;
  };
  costs: Costs[];
  tasks: Tasks[];
}

export interface ResPrepayment {
  id: number;
  cPreparymentID: string;
  cCompanyID: string;
  cCustomerID: string;
  cTotal: number;
  cSurplus: number;
  cCreateTime: "2023-02-28T08:41:12.250Z";
}

export interface ResAccount {
  id: number;
  cAccountID: string;
  cCompanyID: string;
  cNumber: string;
  cName: string;
  cInitialBalance: number;
  cTime: "2023-02-28T09:01:55.427Z";
  cType: number;
  weChat: true;
}

export interface ResReceivables {
  id: number;
  cReceivablesID: string;
  cCompanyID: string;
  cCustomerID: string;
  cAccountID: string;
  cNumber: string;
  cDate: string;
  cProducer: string;
  cBrokerage: string;
  cAuditor: string;
  cRemarks: string;
  cTime: string;
  cAppFlowID: string;
  cNowOrder: number;
  cAppResult: number;
  cRecID: string;
  weChatState: string;
  costRecords: CostRecords[];
}

export interface CostRecords {
  id: number;
  cCostRecordID: string;
  cReceivablesID: string;
  cCompanyID: string;
  cCustomerID: string;
  cContractID: string;
  cCostID: string;
  cAccountID: string;
  cPreparymentID: string;
  cName: string;
  cAmount: number;
  cDiscountAmount: number;
  cAdvance: true;
  cReceivableDate: string;

  cReceivable: string;
}
